export default "__VITE_ASSET__41c0c38b__"